import { TelemetryClient } from '@jarvis/web-stratus-client';

export default async function getJobsPrintAreaCounters({
  authProvider,
  deviceId,
  endDate,
  numDays,
  stack,
  startDate,
}) {
  const client = new TelemetryClient(stack, authProvider);
  const response = await client.getPrintCountersByTenancy(undefined, deviceId, startDate, endDate, numDays);

  return response;
}
